import { Injectable } from '@angular/core';
import { Http, RequestOptions, Response, URLSearchParams } from '@angular/http';

import { environment } from '../../../../environments/environment';
import { getCurrentMillis, getMillisFromDateLikeString } from '../../utils/date.utils';
import { getSession, setSession } from '../storage.service';

@Injectable()
export class AuthHttpService {
  private apiUrl: string;

  constructor(
    private http: Http
  ) {
    this.apiUrl = `${environment.apiUrl}`;
  }

  checkPasswordRecoveringHash(hash) {
    return this.http.get(`${this.apiUrl}recover-password/${hash}`);
  }

  login(email: string, password: string) {
    const url = `${this.apiUrl}login`;
    const body = { email, password };

    return this.http.post(url, body)
      .map(this.saveToken);
  }

  recoverPassword(email) {
    const postBody = { email };
    return this.http.post(`${this.apiUrl}recover-password`, postBody);
  }

  refreshToken() {
    const url = `${this.apiUrl}token/refresh`;
    const session = getSession();
    const refreshToken = (session) ? session.refreshToken : null;
    const params = new URLSearchParams();
    params.append('refresh_token', refreshToken);
    const options = new RequestOptions();
    options.params = params;

    return this.http.post(url, null, options)
      .map(this.saveToken);
  }

  resetPassword(hash, password, passwordRepeat) {
    const postBody = { hash, password, passwordRepeat };

    return this.http.post(`${this.apiUrl}reset-password`, postBody);
  }

  private saveToken = (response: Response) => {
    const serverDelta = getCurrentMillis() - getMillisFromDateLikeString(response.headers.get('date'));
    const data = response.json();
    const session = { token: data.token, refreshToken: data.refresh_token, delta: serverDelta };
    setSession(session);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/api/auth-http.service.ts